<template>
	<div class="info container-secondary-main">
		<h4>{{data.title}}</h4>
		<p class="detail-time">{{data.publish_date != '0' ? data.publish_date : data.add_time}}<!-- &nbsp;&nbsp;&nbsp;&nbsp;润农采购部<i class="el-icon-view"></i><span>11111</span> --></p>
		<div class="info-content">
			<div class="column-center" style="width: 100%;margin: 3rem 0;" v-if="!data.info">
				<img class="type-image" src="@/assets/nodata.gif" alt=""/>
				<div style="margin-top: 2rem;">{{lang.project_no_data}}</div>
			</div>
			<div v-else v-html="data.info"></div>
		</div>
	</div>
</template>

<script>
	import { create } from 'core-js/core/object';
import {
		mapState
	} from 'vuex'
	export default {
		name: "NewsInfo",
		props: {
			data: {
				type: Object, // Prop的类型
				required: true // 该Prop是必需的
			}
		},
		computed: {
			...mapState({
			  lang: state => state.user.lang,
			})
		},
		data() {
			return {}
		},
		created(){
			console.log(this.data,'this.data,')
		}

	}
</script>

<style lang="less" scoped>

	.type-image{
        width: 17.25rem;
        height: 17.25rem;
        background-size: 100% auto;
        background-position: center;
        background-repeat: no-repeat;
    }
	.info {
		background: #FFFFFF;
		border-radius: 8px 8px 8px 8px;
		padding: 2.75rem 1rem;
		text-align: center;

		.detail-time {
			font-size: 0.875rem;
			color: #333333;
			margin-top: 1.25rem;
			border-bottom: 1px solid #f2f2f2;
			padding: 0 4.1875rem 1rem;

			i {
				margin-left: 2rem;
			}

			span {
				color: #398145;
			}
		}

		@media (max-width: 992px) {
			.info-content {
				padding: 0 4% !important;
			}
		}
		.info-content {
			text-align: left;
			font-size: 0.875rem;
			color: #333333;
			margin-top: 3rem;
			padding: 0 4.1875rem;
		}
		.info-content /deep/ img{
			max-width: 100%;
		}
	}
</style>